import axios from "axios";
import { getHost } from "../utils/host";

export const getServiceUrl = () => {
    return `${getHost()}/service.ashx`;
}

export const login = (name, pw) => {
    const params = new URLSearchParams()
    params.append('action', "LOGIN");
    params.append('username', name);
    params.append('password', pw);

    return axios.post(
        getServiceUrl(),
        params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
}

export const getAppConfig = () => {
    const params = new URLSearchParams()
    params.append('action', "GETAPPCONFIG");
    //params.append('url', url);
    return axios.get(getServiceUrl(), { params });
}

// export const getHtml = () => {

//     const params = new URLSearchParams()
//     params.append('action', "gethtml");
//     //params.append('url', url);
//     return axios.get(getServiceUrl(), { params });
// }

export const writeLog = (token, info, tag, status) => {
	const strInfo = typeof info === "object" ? JSON.stringify(info) : info;

    const params = new URLSearchParams();
    params.append('action', "writelog");
    params.append('token', token);
    params.append('info', strInfo);
    params.append('tag', tag);
    params.append('status', status);

    return axios.post(
        getServiceUrl(),
        params, 
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
	);
}

// Per loggare alla chiusura della pagina o del browser
export const writeLogAsBecon = (token, info, tag, status) => {
    const strInfo = typeof info === "object" ? JSON.stringify(info) : info;
	navigator.sendBeacon(`${getServiceUrl()}?action=writelog&token=${token}&info=${encodeURIComponent(strInfo)}&tag=${encodeURIComponent(tag)}&status=${encodeURIComponent(status)}`, null);
}

export const getXml = (token, type) => {
    const params = new URLSearchParams();
    params.append('action', "getxml");
    params.append('token', token);
    params.append('type', type);
    return axios.get(getServiceUrl(), { params });
}

export const saveXml = (token, type, xml) => {
    const params = new URLSearchParams();
	params.append('action', "savexml");
	params.append('type', type);
	params.append('token', token);
	params.append('xml', xml);
    return axios.post(
        getServiceUrl(),
	    params,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
    );
}

export const getLoggedUsers = (token, type) => {
    const params = new URLSearchParams();
    params.append('action', "getloggedusers");
    params.append('token', token);
    return axios.get(getServiceUrl(), { params });
}

export const getLogUser = (token, userId) => {
    const params = new URLSearchParams();
    params.append('action', "getuserlog");
    params.append('token', token);
    params.append('id', userId);
    return axios.get(getServiceUrl(), { params });
}

export const getVideos = (token, pageNumber, pageSize) => {
    const params = new URLSearchParams()
    params.append('action', "getvideos");
    params.append('token', token);
    params.append('page', pageNumber);
    params.append('pageSize', pageSize);
    return axios.get(getServiceUrl(), { params });
}

export const getAllVideos = async (token, pageSize = 50) => {
    let currentPage = 1;
    let totalPages = 1; // Will be updated dynamically from the first response
    let allVideos = [];
    let lastResponse = null
    try {
        do {
            // Fetch the current page
            const response = await getVideos(token, currentPage, pageSize);
            lastResponse = response;
            const data = response.data;

            // Append videos from this page to our main array
            if (data && data.videos) {
                allVideos = allVideos.concat(data.videos);
            }

            // On the first request, read the total pages metadata sent by your backend
            if (currentPage === 1 && data && data.pagination) {
                totalPages = data.pagination.totalPages;
            }

            currentPage++;
        } while (currentPage <= totalPages);

        
        return {
            data: {
                status: lastResponse.data.status,
                userId: lastResponse.data.userId,
                userName: lastResponse.data.username,
                pageTitle: lastResponse.data.pageTitle,
                videos: allVideos
            }
        };
    } catch (error) {
        console.error("Error fetching all videos:", error);
        throw error;
    }
};
